module.exports = __webpack_public_path__ + "media/icf/mcc-0944504b.png";